<template>
  <label class="sr-only">
    Contact me via whatsapp
    <input
      v-model="honeypot"
      name="contact-me-via-whatsapp"
      tabindex="-1"
      type="checkbox"
    />
  </label>
</template>

<script setup lang="ts">
import { useModel } from "@solvari/common-fe/composables";

const props = defineProps({ modelValue: { type: Boolean, default: false } });
const emit =
  defineEmits<(event: "update:modelValue", value: boolean) => void>();

const honeypot = useModel("modelValue", props, emit);
</script>
